import React, {useState, useEffect} from 'react';
import {connect} from 'react-redux';
import {setCurrentStep, setBuyerPersonalData, createOwnershipTransferSellerRequest} from '../OwnershipTransferSellerSlice';

import TextInput from '../../../Shared/TextInput/TextInput';
import {CollapseLabelCheckBox, ServiceType} from '../Constant/Constant';
import {validateInput, TextInputEnum} from '../../../../utilities/validation/InputValidation';
import BtnSubmit from 'app/Components/Shared/Buttons/BtnSubmit';
import useExtendedEffect from '../../../../utilities/hooks/useExtendedEffect';
import {dwhGeneralReport, DWHStatus, DwhActionType, DWHMessageText} from '../Reports/dwhReports';
import CheckboxCollapseLabel from 'app/Components/Shared/CheckboxCollapseLabel/CheckboxCollapseLabel';
import CheckBox from 'app/Components/Shared/CheckBox/Checkbox';
import {styledNumber} from '../../../../utilities/StringHelpers/TitleHelpers';

const BuyerForm = (props) => {
  const [errors, setErrors] = useState({firstName: '', lastName: '', idNumber: '', otpPhone: ''});
  const [showErrorMsg, setShowErrorMsg] = useState(false);
  const [checkbox, setCheckbox] = useState(false);
  const numberRegex = /^\d+$/;

  useExtendedEffect((runSideEffects) => {
    if (runSideEffects()) {
      dwhGeneralReport({
        data: {...props.data, userDetails: props.userDetails},
        actionType: DwhActionType.NewOwnerDetailPage,
        messageText: DWHMessageText.NewOwnerDetailPageDisplayed,
        status: DWHStatus.Ongoing,
      });
    }
  }, []);

  function validateRequiredData() {
    if (
      Object.values(errors).some((value) => value?.trim()) ||
      Object.values(props.data.buyerPersonalData).some((value) => !value || value.trim() === '') ||
      !checkbox
    ) {
      return false;
    } else {
      return true;
    }
  }
  function validateIdNumber(value) {
    if (value?.trim() == props.authentication.loginData.userDetails.IDNumber) {
      return 'מספר תעודת הזהות מקושר כבר לחשבונך';
    } else if (value.startsWith('51')) {
      return 'ערך לא תקין';
    } else {
      return validateInput(value, TextInputEnum.Id);
    }
  }

  function validateAndSend() {
    if (validateRequiredData()) {
      gaButtonClick();
      const reqData = {
        ProductData: {
          AssetExternalId: props.data.serviceToTransfer.assetExternalId,
          SubscriberNo: props.data.serviceToTransfer.subscriberNumber,
        },
        BuyerData: {
          BuyerPhoneNumber: props.data.buyerPersonalData.otpPhone,
          BuyerIdNumber: props.data.buyerPersonalData.idNumber,
          BuyerLastName: props.data.buyerPersonalData.lastName,
          BuyerFirstName: props.data.buyerPersonalData.firstName,
        },
      };
      props.createOwnershipTransferSellerRequest(reqData);
    } else {
      setShowErrorMsg(true);
    }
  }
  function onCheck() {
    setCheckbox(!checkbox);
    setShowErrorMsg(false);
  }

  function getTitle() {
    if (props.data.selectedServiceType == ServiceType.StationaryLine) {
      return `מי יקבל בעלות על שירות ${props.data.serviceToTransfer.packageName}?`;
    } else {
      return `מי יקבל בעלות על קו מספר  ${styledNumber(props.data.serviceToTransfer.subscriberNumber)}?`;
    }
  }
  function gaButtonClick() {
    dwhGeneralReport({
      data: {...props.data, userDetails: props.userDetails},
      actionType: DwhActionType.NewOwnerDetailPage,
      messageText: DWHMessageText.NewOwnerDetailPageButtonClicked,
      status: DWHStatus.Ongoing,
    });
  }

  return (
    <div className='ownership-transfer-form stepContainer customer-form  ownership-transfer-step buyer-form'>
      <div className='l-title center' dangerouslySetInnerHTML={{__html: getTitle()}} />

      <div className='customer-data'>
        <TextInput
          value={props.data.buyerPersonalData.firstName}
          error={errors.firstName}
          id='firstName'
          placeholder={'שם פרטי'}
          onChange={(e) => {
            setErrors({...errors, firstName: validateInput(e.target.value, TextInputEnum.FirstName)});
            props.setBuyerPersonalData({firstName: e.target.value});
            setShowErrorMsg(false);
          }}
          required='required'
        />
        <TextInput
          value={props.data.buyerPersonalData.lastName}
          error={errors.lastName}
          id='lastName'
          placeholder={'שם משפחה'}
          onChange={(e) => {
            setErrors({...errors, lastName: validateInput(e.target.value, TextInputEnum.LastName)});
            props.setBuyerPersonalData({lastName: e.target.value});
            setShowErrorMsg(false);
          }}
          required='required'
        />
        <TextInput
          value={props.data.buyerPersonalData.idNumber}
          error={errors.idNumber}
          id='idNumber'
          placeholder={'ת.ז'}
          pattern='[0-9]*'
          maxLength='9'
          onChange={(e) => {
            if (numberRegex.test(e.target.value) || e.target.value === '') {
              setErrors({...errors, idNumber: validateIdNumber(e.target.value)});
              props.setBuyerPersonalData({idNumber: e.target.value});
              setShowErrorMsg(false);
            }
          }}
          required='required'
        />
        <TextInput
          value={props.data.buyerPersonalData.otpPhone}
          error={errors.otpPhone}
          id='otpPhone'
          placeholder={'מספר נייד'}
          pattern='[0-9]*'
          maxLength='10'
          onChange={(e) => {
            if (numberRegex.test(e.target.value) || e.target.value === '') {
              setErrors({...errors, otpPhone: validateInput(e.target.value, TextInputEnum.Phone)});
              props.setBuyerPersonalData({otpPhone: e.target.value});
              setShowErrorMsg(false);
            }
          }}
          required='required'
        />
      </div>
      <div className='m-sub-title buyer-msg'>
        לאחר האישור, ישלח SMS למספר שהוזן
        <br /> לצורך השלמת העברת הבעלות
      </div>
      <div className='transfer-checkbox'>
        <CheckBox
          id={'checkbox'}
          onCheck={() => onCheck()}
          onUncheck={() => onCheck()}
          checked={checkbox}
          label={
            <CheckboxCollapseLabel
              defaultText={
                props.data.selectedServiceType == ServiceType.StationaryLine
                  ? CollapseLabelCheckBox.stationary.defaultText
                  : CollapseLabelCheckBox.cellular.defaultText
              }
              extendedText={
                props.data.selectedServiceType == ServiceType.StationaryLine
                  ? CollapseLabelCheckBox.stationary.extendedText
                  : CollapseLabelCheckBox.cellular.extendedText
              }
            />
          }
        />
      </div>

      <div></div>
      <div className='continue-button'>
        {showErrorMsg && <div className='error center'>כדי להמשיך יש למלא את כל שדות החובה</div>}
        <BtnSubmit onclick={() => validateAndSend()} text={'אישור העברת הבעלות'} />
      </div>
    </div>
  );
};

const mapStateToProps = (state) => ({
  data: state.OwnershipTransferPrivateSeller,
  authentication: state.authentication,
  productsAndServices: state.selfcarePage,
  userDetails: state.authentication?.loginData?.userDetails,
});

const mapDispatchToProps = {
  setCurrentStep,
  setBuyerPersonalData,
  createOwnershipTransferSellerRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(BuyerForm);
